import React, { useContext, useEffect, useState } from "react";
import { Select } from "antd";
import { OrgContext } from "../../context/OrgContext";
import { OrderConfigContext } from "../../context/OrderConfigContext";
import MoveTypeBadge from "../../components/common/MoveTypeBadge";

const OrderTypeSelect = ({
  multiSelect = false, // Toggle for multi-select
  //options = [],
  disabledCodes = ["SDR", "SDD", "MDR", "MDD"], // Array of options for the dropdown
  value, // Current value of the select
  onChange, // Callback for when the selection changes
  placeholder = "Select", // Placeholder text
  ...props // Additional props to pass to the Select component
}) => {
  const { orgSettings } = useContext(OrgContext);
  const { orderConfig, omtByOrderLabel = {} } = useContext(OrderConfigContext);
  const [options, setOptions] = useState([]);
  useEffect(() => {
    // Move-type-driven orgs (service_level_flow_enabled): options come from the
    // org's ACTIVE move-type catalog — badge + alias per option, value stays the
    // order_label so the existing filter param/backend match is unchanged.
    // omtByOrderLabel is only populated under the flag; empty -> legacy options.
    const omtLabels = Object.keys(omtByOrderLabel);
    if (omtLabels.length > 0) {
      setOptions(
        omtLabels
          .filter((label) => !disabledCodes.includes(label))
          .map((label) => ({
            label: omtByOrderLabel[label].alias_name || label,
            value: label,
            badge: omtByOrderLabel[label],
          }))
      );
      return;
    }
    const { ui_version, order_types = ""} = orgSettings;
    const orderTypes = _.split(order_types, ",")
      const options = ui_version === 'v2' ? (orderTypes
      ? orderConfig.enhancedOrderTypes
          .filter(
            (rec) =>
              !disabledCodes.includes(rec.code) &&
              (orderTypes.length === 0 || orderTypes.includes(rec.code) || orderTypes.includes(rec.extraCode))
          )
          .map(
            (item) => (
              {
                label: item.label,
                value: item.extraCode || item.code,
              }
            )
          )
      : []) : Object.keys(orderConfig.orderTypeKeysForFilter)
        .filter((order) => order !== !disabledCodes.includes(order))
        .map((item) => (
            {
              label: orderConfig.orderTypeKeysForFilter[item],
              value: item,
            }
          )
        )
    setOptions(options);
  }, [orgSettings, omtByOrderLabel]);
  return (
    <Select
      mode={multiSelect ? "multiple" : undefined} // Enables multiple selection mode if multiSelect is true
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      dropdownMatchSelectWidth={false}
      // Options may render badge JSX — keep the closed box / tags to plain text.
      optionLabelProp="label"
      // Type-ahead over the visible label (alias) rather than the JSX children.
      showSearch
      filterOption={(input, option) =>
        String(option.props.label || option.props.children || "")
          .toLowerCase()
          .includes(String(input).toLowerCase())
      }
      style={{ width: "100%" }} // Custom styling, can be modified or added as needed
      {...props}
    >
      <Select.Option value={multiSelect ? "ALL" : '' } key="all" label="-- All --">
        -- All --
      </Select.Option>
      {options.map((option) => (
        <Select.Option key={option.value} value={option.value} label={option.label}>
          {option.badge ? (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <MoveTypeBadge
                shortCode={option.badge.short_code}
                color={option.badge.display_color}
                title={option.label}
              />
              {option.label}
            </span>
          ) : (
            option.label
          )}
        </Select.Option>
      ))}
    </Select>
  );
};

export default OrderTypeSelect;
